export const validateRequired = (props) => {
  const keys = Object.keys(props);
  for (const key of keys) {
    if (props[key] == null) {
      throw new Error(`Missing required property ${key}.`);
    }
  }
};
